import { useEffect, useState } from 'react';
import { FormApi } from 'final-form';

export function useFormFieldWatch<T>(form: FormApi<T> | undefined, fieldName: keyof T, initialValue?: unknown) {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    const unsubscribe = form?.registerField(
      // @ts-ignore
      fieldName as string,
      fieldState => {
        setValue(fieldState.value);
      },
      { value: true },
    );

    return unsubscribe;
  }, [form, fieldName]);

  return value;
}
